// extracted by mini-css-extract-plugin
export default {"advertSearchLink":"NKLlZUVJ","advertSearchIcon":"oO2OrdlQ"};